
import styled, { css } from "styled-components";

import wowTiles from "./theme-background.jpg";

export interface ISidebarContainerProps {
	highlightActive?: boolean;
	leftSize?: number | string;
	rightSize?: number | string;
	alpha: number;
	barOpen: boolean;
}

const SidebarContainer = styled.div<ISidebarContainerProps>`
	display: flex;
	width: 100%;
	overflow: hidden;

	& > .main-container {
		flex-grow: 1;
		max-width: 100%;
	}

	& > .sidebar-left,
	& > .sidebar-right {
		background-color: rgba(48, 64, 78, ${({alpha}) => alpha || "0.85"});
		transition-property: min-width, width, opacity;
		transition-duration: 0.3s;
		min-width: 0;
		width: 0;
		opacity: 0.5;
		position: fixed;
		top: 0;
		bottom: 0;
		z-index: 8001;

		${({barOpen}) => !barOpen && css`
			cursor: pointer;
		`}
	}

	& > .sidebar-left {
		box-shadow: 1px 0px 5px -1px rgba(48, 64, 78, 0.3);
		left: 0;
		border-right: 5px solid rgb(26,30,32);
	}

	& > .sidebar-right {
		box-shadow: -1px 0px 5px -1px rgba(48, 64, 78, 0.3);
		right: 0;
		border-left: 5px solid rgb(26,30,32);
	}

	&.open > .sidebar-left,
	&.open > .sidebar-right {
		opacity: 1;
		width: auto;
	}

	&.open > .sidebar-left {
		right: ${({leftSize}) => leftSize ? 'calc(100vw - ' + leftSize + 'px)' : 'calc(100vw - 300)px'};
	}

	&.open > .sidebar-right {
		left: ${({rightSize}) => rightSize ? 'calc(100vw - ' + rightSize + 'px)' : 'calc(100vw - 300)px'};
	}

	${({highlightActive}) => highlightActive ? css`
		&.open .editing-active {
			box-shadow: 0px 0px 13px 0px #137cbd;
		}
	` : ''}

	& .bp3-overlay {
		z-index: 8500;
	}

	${({theme}) => "doge" === theme && `
		& .sidebar-left div, & .sidebar-right div {
			color: #eb53ce;
			font-size: 18px;
			font-family: "Comic Sans MS", cursive, sans-serif;
		}

		& .sidebar-left, .sidebar-right {
			background-image: url(${wowTiles});
		}
	`}
`;

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/core/components/editor/styled/SidebarContainer.tsx